import WixSDK from 'shared/utils/wix-sdk';
import { BI_EVENT } from 'shared/bi/bi-handler';

export function sendsBiEvent(eventName, getParams = _.noop) {
  return function (target, name, descriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function wrappedMethod(...args) {
      WixSDK.PubSub.publish(BI_EVENT, {
        eventName,
        params: getParams.apply(this, args),
      });
      originalMethod.apply(this, args);
    };

    return descriptor;
  };
}



// WEBPACK FOOTER //
// ./src/shared/bi/sends-bi-event.js